/* eslint-disable */
<template>
  <div class="deposito flex flex-col w-full">
    <template v-if="!thirdPartyUrl">
      <div class="mt-4 px-[20px] flex-1">
        <div class="text-[15px]">{{ $t("Deposit.Paymentchannel") }}</div>
        <div class="w-full h-[35px] m-auto overflow-x-auto relative mt-4">
          <div class="absolute flex gap-[10px]" v-if="isChannelLoading">
            <template v-if="paymentType?.length">
              <template v-for="item in paymentType" :key="item.maxPayeeAmt">
                <div class="relative">
                  <div :class="[
                    'w-[85px] h-[35px] text-[18px] flex justify-center items-center rounded-[6px] cursor-pointer',
                    'active_tab_btn',
                  ]">
                    PIX
                  </div>
                  <div v-if="item.type === 'TestPay'"
                    class="absolute top-[-2px] right-[-10px] w-[20px] h-[20px] rounded-full bg-[red] text-white text-[10px] flex-center">
                    T
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="text-[12px] flex justify-center items-center">
                <Image :src="noData" alt="" class="w-[24px] h-[24px] mr-[10px]" />
                <span class="text-[12px] text-[#FF3B30]">{{
                  $t("Deposit.noChannel")
                  }}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="w-full mt-6 checker">
          <!-- 单选 -->
          <template v-if="enabled">
            <van-checkbox v-model="isDiscount">
              <span class="txt">{{
                $t("Deposit.ParticipateInpromotions")
}}</span>
              <template #icon>
                <!-- <img
                  class="h-[22px] w-[22px]"
                  :src="isDiscount ? activeIcon : inactiveIcon"
                /> -->
                <span class="checkIcon" :class="isDiscount ? 'active' : 'inactive'"></span>
              </template>
            </van-checkbox>
          </template>
        </div>

        <!-- 输入金额 -->
        <div class="h-[50px] rounded-xl mt-[10px] flex items-center relative">
          <span class="absolute left-[15px] font-bold text-[var(--theme-gray-gold)] text-[15px]">
            R$
          </span>
          <van-field :disabled="!paymentType?.length" :placeholder="`${$t('Deposit.valor')}(${formatNumberAsMoney(
            formatter().format(limitMin || 0)
          )} ~ ${formatNumberAsMoney(formatter().format(limitMax || 0))})`" v-model="money" @input="handleInput"
            inputmode="numeric"
            class="w-[100%] h-[100%]  pl-[47px] rounded-xl bg-[var(--inner-table-bg-color40)] text-[15px] indent-[47px] border-none placeholder:text-[15px] placeholder:text-[#FFFFFFBF] focus:outline-none focus:ring-[var(--theme-primary)] focus:ring-[2px] focus:bg-[#5a4be2 ]" />
          <div class="absolute right-[15px] flex items-center gap-[10px]">
            <template v-if="money">
              <van-icon name="close" @click="money = null" />
            </template>
          </div>
        </div>
        <!-- 优惠金额 -->
        <template v-if="isDiscount && giftMoneyArr.length">
          <div
            class="h-[50px] rounded-xl bg-[var(--inner-table-bg-color40)] flex items-center gap-[10px] mt-[20px] pl-[15px] text-[#bcbec1]">
            <Image class="w-[24px]" :src="disCount" alt="" />
            <span class="text-[15px]">
              {{ $t("Deposit.Participate") }}
              {{ discountAmount }}
            </span>
          </div>
        </template>
        <!-- 优惠金额 -->
        <div v-if="isChannelLoading" class="flex justify-between flex-wrap mt-[10px] bn">
          <template v-if="enabled && isDiscount">
            <div v-for="item in giftMoneyArr" :key="item.giftCode">
              <button :class="['!w-[100px] !h-[38px]  mr-[5px]  mt-[10px] !font-[300] !rounded-[8px]',
                chooseBtn?.giftCode !== item.giftCode
                  ? 'primaryBtn_transparent !border-[1px] !border-solid !border-[#fff]/50'
                  : 'primaryBtn',
              ]" @click="
                () => {
                  chooseBtn = item;
                  maxAmount = item?.maxAmount || 100;
                }
              ">
                <span :class="{
                  ' font-[600]': chooseBtn?.giftCode === item.giftCode,
                }">
                  {{ dealProportion(item.rewardRatios) }}%
                </span>
              </button>
            </div>
          </template>
          <template v-else>
            <div v-for="item in generalMoneyArr" :key="item.amount">
              <button :class="[
                '!w-[100px] !h-[38px] !border-[1px] !font-[300] !border-solid !border-[#fff]/50 !rounded-[8px] mr-[5px] mt-[10px]',
                Number(item.amount) > limitMax || Number(item.amount) < limitMin
                  ? 'opacity-40'
                  : '',
                Number(money) !== Number(item.amount)
                  ? 'primaryBtn_transparent'
                  : 'primaryBtn',
              ]" :disabled="Number(item.amount) > limitMax || Number(item.amount) < limitMin
                " @click="
                  () => {
                    money = item.amount;
                  }
                ">
                <span :class="[
                  Number(money) === Number(item.amount)
                    ? 'text-[#151A1F]  font-bold'
                    : '',
                  'text-[14px]',
                ]">
                  R$ {{ formatter().format(item.amount) }}
                </span>
              </button>
            </div>
          </template>
        </div>
        <!-- 无优惠打码量说明 -->
        <template v-if="!isDiscount || !giftMoneyArr.length">
          <!-- <div
              class="h-[45px] rounded-[8px] border-[1px] border-solid border-[#FFFFFF] flex items-center gap-[10px] mt-[20px] pl-[15px] text-[#fff] opacity-50"
            >
              <Image :src="important" alt="" class="w-[24px] h-[24px]" />
              <span class="text-[13px]">
                {{
                  $t("Deposit.NoDiscountCodeQuantity", { turnoverTimes: formatter().format(turnoverTimes) })
                }}
              </span>
            </div> -->
        </template>
        <!-- 有优惠打码量说明 -->
        <template v-else>
          <div v-if="giftMoneyArr.length"
            class="rounded-xl border-[1px] border-solid text-[12px] border-[#fff]/75 mt-[20px] p-[10px] text-[#fff]/75">
            <div class="flex items-start gap-[10px] leading-[22px]">
              <div class="rounded-[50%] mt-1">
                <Image :src="important" class="w-[16px] h-[16px]" alt="" />
              </div>
              <div>
                <p>
                  {{
                    $t("Deposit.DepositReceives", {
                      rewardRatios: dealProportion(chooseBtn?.rewardRatios),
                    })
                  }}
                </p>
                <p>
                  {{
                    $t("Deposit.MaximumBonusAmount", {
                      maxAmount: formatter().format(chooseBtn?.maxAmount),
                    })
                  }}
                </p>
                <p>
                  {{
                    $t("Deposit.BonusCanBeWthdrawn", {
                      rollingRatio: formatter().format(chooseBtn?.rollingRatio),
                    })
                  }}
                </p>
              </div>
            </div>
            <div class="flex items-center gap-[10px] leading-[22px]">
              <div>
                <img :src="chooseBtn?.userCondition ? right : error" class="w-[16px] h-[16px]" alt="" />
              </div>
              <span>
                {{ userTypeOptions[chooseBtn?.scope]?.text }}
                <template v-if="chooseBtn?.scope !== 'All' && chooseBtn?.scope !== 'FirstDeposit'">
                  {{ formatter().format(chooseBtn?.configAmount) }}
                </template>
              </span>
            </div>
            <div class="flex items-center gap-[10px] leading-[22px]">
              <div class="rounded-[50%]">
                <img :src="chooseBtn?.dailyCondition ? right : error" class="w-[16px] h-[16px]" alt="" />
              </div>
              <span>
                <template v-if="chooseBtn?.perDayRewardTimes > 0">
                  {{
                    $t("Deposit.TimesADay", {
                      perDayRewardTimes: chooseBtn?.perDayRewardTimes,
                    })
                  }}
                </template>
                <template v-else>{{ $t("Deposit.NoLimitOfTimes") }}</template>
              </span>
            </div>
          </div>
        </template>
        <div class="text-[#fff]/50 mt-6">
          <van-button :loading="isLoading" :class="[
            +money >= limitMin &&
              +money <= limitMax &&
              !isLoading &&
              (!isDiscount || (chooseBtn?.userCondition && chooseBtn?.dailyCondition) || !giftMoneyArr.length)
              ? 'primaryBtn'
              : 'primaryBtn_transparent',
          ]" :disabled="+money < limitMin ||
            +money > limitMax ||
            isLoading ||
            (isDiscount && !chooseBtn?.userCondition && giftMoneyArr.length) ||
            (isDiscount && !chooseBtn?.dailyCondition && giftMoneyArr.length)
            " @click="handleDeposito()">
            {{ $t("meu.Deposit") }}
          </van-button>
        </div>
        <van-popup v-if="openModal" v-model:show="openModal" position="bottom" :lock-scroll="false" :style="{
          height: isgame ? '100%' : '70%',
        }">
          <PopPage :uuPayForm="uuPayForm" @closeModal="openModal = false" :_createOrder="_createOrder" />
        </van-popup>
      </div>
    </template>
    <template v-else>
      <iframe class="w-full h-[calc(100vh-52px)]" frameborder="0" :src="thirdPartyUrl"
        style="overflow: hidden"></iframe>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import useTrack from "@/hooks/useTrack";
import { formatter, formatNumberAsMoney } from "@/utils";
import { getMoney, getRechargeConfig } from "@/api/saque";
import { getProportionButtonList, createOrder } from "@/api/deposito";
import type { iType } from "@/types/index";
import { useUserInfo } from "@/store";
import debounce from "lodash-es/debounce";
// import activeIcon from "./images/check.png";
// import inactiveIcon from "./images/nocheck.png";
import disCount from "./images/disCount2.png";
import important from "./images/important.png";
import right from "./images/right.png";
import error from "./images/error.png";
import PopPage from "./compontents/PopPage.vue";
import noData from "./images/noData.png";
import useTrackPayResult from "@/hooks/useTrackPayResult";
import { useSystemInfo } from "@/store";
const router = useRouter();
const isgame = ref(router.currentRoute.value.path.includes("game"))
const { track2Platform, trackName } = useTrack();
const token = useUserInfo().userInfo?.token;
import i18n from "@/i18n";
const t = i18n.global.t;
const userTypeOptions = {
  All: {
    text: t("Deposit.UserTypeOptions.All"),
  },
  FirstDeposit: {
    text: t("Deposit.UserTypeOptions.FirstDeposit"),
  },
  CurrentDeposit: {
    text: t("Deposit.UserTypeOptions.CurrentDeposit"),
  },
  CurrentBet: {
    text: t("Deposit.UserTypeOptions.CurrentBet"),
  },
  AccumulateDeposit: {
    text: t("Deposit.UserTypeOptions.AccumulateDeposit"),
  },
  AccumulateBet: {
    text: t("Deposit.UserTypeOptions.AccumulateBet"),
  },
};
const emit = defineEmits(["next", "prev", "finish"]);

const paymentType = ref<iType[]>([]); //渠道列表

const limitMin = ref<any>(null); //最小金额
const limitMax = ref<any>(null); //最大金额
const money = ref<any>(null); //输入金额
const isLoading = ref<boolean>(false); //是否加载中
const isDiscount = ref<boolean>(false); //是否优惠
const chooseBtn = ref<any>({}); //选择优惠
const enabled = ref<boolean>(false); //是否启用
const maxAmount = ref<any>(1000); //优惠最大金额
const giftMoneyArr = ref<any>([]); //优惠金额
const generalMoneyArr = ref<any>([]); //普通金额
const openModal = ref(false); //是否打开弹窗
const uuPayForm = ref<any>({ payeeName: "", payeeCpf: "", isCpf: "" }); //uu支付表单
const thirdPartyUrl = ref<any>(""); //第三方url
const discountAmount = ref<any>(0); //优惠金额
const isChannelLoading = ref(false); //是否加载中
// 获取渠道列表

const loadingToast = showLoadingToast({
  message: "loading...",
  forbidClick: true,
  duration: 0,
});
const rechargeConfig = async () => {
  try {
    const { data, code } = await getRechargeConfig();
    if (code === 1) {
      paymentType.value = [data];
      limitMin.value = data?.minPayeeAmt;
      limitMax.value = data?.maxPayeeAmt;
      generalMoneyArr.value = data?.amounts
        ? data?.amounts.map((item: any) => ({
          amount: item,
        }))
        : [];
      loadingToast.close();
      isChannelLoading.value = true;
    }
  } catch (error) {
    loadingToast.close();
    console.log("getChannelList - error:", error);
  }
};

// 获取充值比例按钮列表
const getProportionButtonListData = async () => {
  try {
    const { code, data }: any = await getProportionButtonList();
    if (code === 1) {
      enabled.value = data.enabled;
      if (enabled.value && data.display == "DepositBonus") {
        isDiscount.value = true;
      }
      giftMoneyArr.value = data.detailList;
      chooseBtn.value = giftMoneyArr.value[0];
    }
  } catch (error) {
    console.log("getProportionButtonList - error:", error);
  }
};

// 输入金额
const handleInput = (e: any) => {
  const value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  const num = Number(value) > limitMax.value ? limitMax.value : value;
  const formattedNum = num.includes(".")
    ? num.split(".")[0] + "." + num.split(".")[1].slice(0, 2)
    : num;
  money.value = formattedNum;
};

// 处理比例
const dealProportion = (val: any) => {
  const floatValue = parseFloat(val);
  if (floatValue % 1 === 0) {
    return floatValue.toFixed(0);
  } else {
    if (useSystemInfo().language === "pt") {
      return floatValue.toString().replace(".", ",");
    } else {
      return floatValue.toString();
    }
  }
};

// 提交
const handleDeposito = debounce(async () => {
  track2Platform(trackName.RechargeClick);

  if (isLoading.value) return;
  isLoading.value = true;
  _createOrder();
}, 1000);

// 从router里获取query.params.id，作为直充详情ID，如果没有表示是直接充值并非为了领取翻倍奖励
const route = useRoute();
const cashDetailId = route.query.cashDetailId;

// 创建订单
const _createOrder = async (data = {}) => {
  //在这里加入了直充详情ID（cashDetailId）以便领取翻倍奖励
  try {
    let res = await createOrder({
      amount: +money.value,
      ...uuPayForm.value,
      ...(cashDetailId && { cashDetailId }), // 只有当 cashDetailId 存在时才添加这个字段
      ...((isDiscount.value && giftMoneyArr.value.length) && { giftCode: chooseBtn.value.giftCode }),
      ...data,
    });
    if (res.code === 1) {
      // limitReturnUrl 为true跳转我们的支付页面，为false跳转第三方页面
      if (res.data.limitReturnUrl) {
        //模拟充值
        if (router.currentRoute.value.path.includes("game")) {
          emit("next", 2, {
            orderNo: res.data.merchantOrderNo,
            token,
            ...res.data,
          });
        } else {
          router.push({
            path: "/DepositoQRcode",
            query: { orderNo: res.data.merchantOrderNo, token, ...res.data },
          });
        }
      } else if (res.data.orderStatus == "PullFailed") {
        // 拉单失败
        if (router.currentRoute.value.path.includes("game")) {
          emit("next", 3, {
            orderNo: res.data.merchantOrderNo,
            ...res.data,
            status: "PullFailed",
          });
        } else {
          router.push({
            path: "/DepositoResults",
            query: { orderNo: res.data.merchantOrderNo, ...res.data, status: "PullFailed" },
          });
        }
      } else {
        //第三方链接返回不正规直接返回充值错误页
        if (res.data.payUrl.includes("https://")) {
          thirdPartyUrl.value = res.data.payUrl;
        } else {
          router.push({
            path: "/DepositoResults",
            query: { orderNo: res.data.merchantOrderNo, ...res.data, status: "PullFailed" },
          });
        }
      }

      track2Platform(trackName.InitiateCheckout, {
        value: +money.value,
        currency: res.data.currency,
        product_catalog_id: res.data.id,
      });

      useTrackPayResult(res.data.merchantOrderNo);
    }
    // 用户没有绑定姓名或身份证
    if (res.code == -3602 && res.i18n == "pay.user.name.or.cpf.missing") {
      uuPayForm.value = {
        payeeName: "",
        payeeCpf: "",
        isCpf: false,
      };
      openModal.value = true;
      isLoading.value = false;
    }
  } finally {
    isLoading.value = false;
  }

  return { code: 1 };
};

// 监听money的变化
watch([money, chooseBtn], ([newVal, newChooseBtn]) => {
  discountAmount.value =
    (newVal * (newChooseBtn?.rewardRatios || 0)) / 100 > maxAmount.value
      ? formatter().format(maxAmount.value)
      : formatter().format(
        parseFloat(
          (
            Math.floor(((newVal * (newChooseBtn?.rewardRatios || 0)) / 100) * 100) / 100
          ).toFixed(2)
        )
      );
});

const getMoneyData = async () => {
  const { data, code } = await getMoney();
  if (code === 1) {
    if (data.accountName && data.cpf) {
      uuPayForm.value.payeeName = data.accountName;
      uuPayForm.value.payeeCpf = data.cpf;
      uuPayForm.value.isCpf = "";
    } else {
      uuPayForm.value.isCpf = false;
    }
  }
};

onMounted(() => {
  rechargeConfig();
  getProportionButtonListData();
  getMoneyData();
  track2Platform(trackName.AddToCart);
});
</script>

<style lang="scss" scoped>
.van-checkbox {
  --van-checkbox-label-color: #fff;
  font-size: 14px;
}

.deposito {
  --active-btn: url('#{$baseURL}/assets/check.png');
  --inactive-btn: url('#{$baseURL}/assets/nocheck.png');

  .checkIcon {
    width: 22px;
    height: 22px;
    display: inline-block;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;

    &.active {
      background-image: var(--active-btn);
    }

    &.inactive {
      background-image: var(--inactive-btn);
    }
  }

  .checker {
    .txt {
      color: #ff5927;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>
